import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export const get_my_relation_detail = createAsyncThunk(
  'IRInviteSlice/get_my_relation_detail',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/relation/get_my_relation_detail',
      {
        mid: store.getState().env.deviceinfo.h_m,
        ...p,
      },
      {store}
    )
    return resp.data?.data
  }
)

const initialState: any = {}
export const IRInviteSlice = createSlice({
  name: 'IRInvite',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(get_my_relation_detail.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})

export default IRInviteSlice.reducer
